export default "/images/8ceacf23a19793bae6385180095444db.avif";